import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Rooms from './pages/Rooms';
import RoomDetail from './pages/RoomDetail';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import Admin from './pages/Admin';
import { SiteContentProvider } from './context/SiteContent';
import './App.css';
import './modern.css';

const pageTitles = {
  '/': 'Home',
  '/rooms': 'Our Rooms',
  '/about': 'About Us',
  '/gallery': 'Gallery',
  '/contact': 'Contact',
  '/booking': 'Booking & Availability',
  '/admin': 'Content Studio'
};

function PageFrame() {
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/+$/, '').toLowerCase() || '/';
  const isAdmin = normalizedPath === '/admin';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const roomDetail = location.pathname.startsWith('/rooms/');
    const pageTitle = roomDetail ? 'Room Details' : pageTitles[normalizedPath] || 'Home';
    document.title = `${pageTitle} | K and son’s Guest House`;
  }, [location.pathname, normalizedPath]);

  return (
    <>
      {!isAdmin && <Header />}
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {isAdmin ? (
            <Admin />
          ) : (
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/rooms" element={<Rooms />} />
              <Route path="/rooms/:id" element={<RoomDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/admin/*" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          )}
        </motion.div>
      </AnimatePresence>
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  return <BrowserRouter><SiteContentProvider><PageFrame /></SiteContentProvider></BrowserRouter>;
}